import React from 'react';
import type File from '../../interfaces/File';

import { timeSince, dateFromTicks } from '../../services/utils';

interface FilesTableDeletionDateCellProps {
  file: File;
}

const FilesTableDeletionDateCell: React.FC<FilesTableDeletionDateCellProps> = ({ file }) => {
  return <span>{timeSince(dateFromTicks(file.deletedAt)) || '-'} </span>;
};

export default FilesTableDeletionDateCell;
